export const PRIMARY_OPTIONS = ['ROAS', '광고비', '노출 수', '클릭 수', '전환 수', '매출'];
export const PERIOD_OPTIONS = ['일간', '주간'];
